import { render, staticRenderFns } from "./CollectScroll.vue?vue&type=template&id=7c1b654c&scoped=true&"
import script from "./CollectScroll.vue?vue&type=script&lang=js&"
export * from "./CollectScroll.vue?vue&type=script&lang=js&"
import style0 from "./CollectScroll.vue?vue&type=style&index=0&id=7c1b654c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1b654c",
  null
  
)

export default component.exports